module.exports = __webpack_public_path__ + "static/media/debian.28695986.svg";